import { useState } from "react";
import { Tooltip, IconButton, CircularProgress} from "@mui/material";

import PrintRoundedIcon from '@mui/icons-material/PrintRounded';

import FileDownloader from "../../FileDownloader";

const DownloadButton = ({ url, doc_type = "pdf", filename = "invoice", filetype = "application/pdf", title = "Print PDF", noColor = false }) => {
  const [loading, setLoading] = useState(false);

  let query = `?doc_type=${doc_type}`;

  const downloadFile = async () => {
    if (!url) return;
    let fileDownloader = new FileDownloader();
    setLoading(true);
    try {
      await fileDownloader.downloadAndDisplayPdf(`${url}${query}`, filename, "", filetype);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  }
  return (
    <Tooltip title={title}>
      <IconButton size="small" color={!noColor ? "success" : ""} onClick={downloadFile}>
        {loading ? <CircularProgress size={20} /> : <PrintRoundedIcon size="small" />}
      </IconButton>
    </Tooltip>
  )
};

export default DownloadButton;